import { memo, type CSSProperties, type ReactNode } from 'react';

/** Toolbar min-h-11 + vertical padding + bottom spacer; keeps sticky table header stable. */
const KB_TOOLBAR_STICKY_HEIGHT_PX = 52;

export type KBContentsSectionProps = {
  toolbar: ReactNode;
  children: ReactNode;
};

export const KBContentsSection = memo(function KBContentsSection({
  toolbar,
  children,
}: KBContentsSectionProps) {
  return (
    <div
      style={
        {
          '--kb-toolbar-height': `${KB_TOOLBAR_STICKY_HEIGHT_PX}px`,
        } as CSSProperties
      }
    >
      <div className='sticky top-0 z-30 bg-gray-50 pb-2'>
        <div className='min-h-11'>{toolbar}</div>
      </div>
      {children}
    </div>
  );
});
